import gsap from 'gsap'
import Base from '../../../src/js/classes/Base'

export default class ProductTease extends Base {
	constructor(el) {
		super({
			element: el,
			elements: {
				colorButton: '.c-ProductTease__colors button',
				colors: '.c-ProductTease__colors__info',
				color: '.c-ProductTease__colors__info__color',
				productImages: '.c-ProductTease__images__image',
				productImageGroups: '.c-ProductTease__images__group ',
			},
			options: {},
			classes: {
				active: 'active',
			},
			state: {
				isColorsOpen: false,
				counter: 0,
			},
		})
	}

	init() {
		this.elements.color = gsap.utils.toArray(this.elements.color)
		this.elements.productImages = gsap.utils.toArray(this.elements.productImages)
		this.elements.productImageGroups = gsap.utils.toArray(this.elements.productImageGroups)
		this.addEvents()
	}

	addEvents() {
		if (this.elements.colorButton) {
			this.elements.colorButton.addEventListener('click', this.onClickColorButtons.bind(this))
			this.elements.color.forEach((color) => {
				color.addEventListener('mouseenter', this.onEnterColor.bind(this))
			})
		}
		this.elements.productImageGroups.forEach((group) => {
			group.addEventListener('mousemove', this.onMouseMoveGroup.bind(this))
		})
	}

	onEnterColor(e) {
		this.state.counter = 0
		const id = e.target.dataset.sColorId
		const group = this.elements.productImageGroups.find((group) => group.dataset.sColorId === id)
		if (group) {
			this.elements.productImageGroups.forEach((image) => image.classList.remove(this.classes.active))
			group.classList.add(this.classes.active)
		}
	}

	onMouseMoveGroup(e) {
		const threshold = 12
		const group = e.target

		if (!group.classList.contains(this.classes.active)) {
			return
		}

		this.state.counter++
		if (this.state.counter >= threshold) {
			this.state.counter = 0
			const images = gsap.utils.toArray('.c-ProductTease__images__image', group)
			let activeImage = null

			images.forEach((image) => {
				if (image.classList.contains(this.classes.active)) {
					activeImage = image
				}
				image.classList.remove(this.classes.active)
			})
			// Determine the next image to activate
			const nextImage = activeImage.nextElementSibling || group.firstElementChild

			// Add 'active' class to the next image
			nextImage.classList.add(this.classes.active)
		}
	}

	onClickColorButtons(e) {
		if (this.state.isColorsOpen) {
			this.closeColors()
		} else {
			this.openColors()
		}
	}

	closeColors() {
		this.state.isColorsOpen = false
		this.elements.colorButton.classList.remove(this.classes.active)
		gsap.to(this.elements.colors, {
			clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)',
			duration: 0.2,
			ease: 'power1.in',
		})
	}

	openColors() {
		this.state.isColorsOpen = true
		this.elements.colorButton.classList.add(this.classes.active)
		gsap.to(this.elements.colors, {
			clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
			duration: 0.3,
			ease: 'power2.out',
		})
	}

	removeEvents() {
		if (this.elements.colorButton) {
			this.elements.colorButton.removeEventListener('click', this.onClickColorButtons.bind(this))
			this.elements.color.forEach((color) => {
				color.removeEventListener('mouseenter', this.onEnterColor.bind(this))
			})
		}
		this.elements.productImageGroups.forEach((group) => {
			group.removeEventListener('mousemove', this.onMouseMoveGroup.bind(this))
		})
	}

	resize() {}

	update() {}

	unmount() {
		this.removeEvents()
	}
}
